import React from 'react';

import { Image } from '@change/ds-core-ui';

import { ParallaxWrapper } from 'src/app/shared/components/ParallaxWrapper';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

import { usePetitionMedia } from './hooks/usePetitionMedia';

export const PetitionMedia: React.FC = () => {
	const {
		data: { photo },
	} = usePetitionMedia();

	const isMobile = useIsMobile();

	if (!photo) return null;

	return (
		<div className="-mb-[1rem]">
			<ParallaxWrapper className="h-[11.88rem] md:h-[19.57rem]">
				<Image
					width="100%"
					height="100%"
					src={isMobile ? photo.mobileUrl : photo.url}
					alt=""
					data-qa="hero-image"
					className="md:rounded-t-large h-full w-full object-cover"
				/>
			</ParallaxWrapper>
		</div>
	);
};
